export default __webpack_public_path__ + "static/media/6.73f6234b.jpeg";